import React from 'react';
import kwalifikacje from '../../../assets/kwalifikacje.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Qualifications = () => {
    return (
        <section className="qualifications">
            <div className="container">
                <div className="qualifications__text-image">
                    <div className="qualifications__image-box">
                        <LazyLoadImage width="500" height="722" effect="blur" className="qualifications__image" src={kwalifikacje} alt="Kwalifikacje zdjęcie" />
                    </div>
                    <div className="qualifications__text-box">
                        <p className="qualifications__paragraph">
                            Nazywam się Maria Maj-Kowal, ukończyłam studia magisterskie na Collegium 
                            Medicum Uniwersytetu Jagiellońskiego na kierunku Fizjoterapia.<br />Od 2017
                            roku jestem doktorantką Wydziału Nauk o&nbsp;Zdrowiu CMUJ, gdzie prowadzę
                            badania naukowe w&nbsp;obszarze fizjoterapii w&nbsp;chorobach wewnętrznych.<br />Jako
                            czynny rehabilitant, swoją wiedzą dzielę się także z&nbsp;innymi osobami
                            podczas prowadzonych przeze mnie szkoleń i&nbsp;warsztatów z&nbsp;najnowszych
                            metod, którymi&nbsp;posługuję się na co dzień.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Qualifications;